<template>
	<div class="page-wrap">
		<!-- 背景图片 -->
		<el-image class="pbg" :src="require('@/static/login.svg')" fit="cover"></el-image>
		<!-- 登录卡片 -->
		<div class="login-card animate__animated animate__fadeIn">
			<!-- 标题 -->
			<!-- <p class="title fade-up" style="animation-delay: 0.1s">欢迎登录</p> -->
			<!-- 图标 -->
			<div class="icon-wrap">
				<el-image :src="require('@/static/add2/logo.png')"></el-image>
			</div>
			<!-- 手机号/邮箱输入 -->
			<div class="input-area phone-area fade-up f-ct" style="animation-delay: 0.3s">
				<el-image :src="require('@/static/2.svg')"></el-image>
				<el-input v-model="account" :placeholder="$t('loginPage.accountPlaceholder')"></el-input>
			</div>
			<!-- 验证码输入 -->
			<div v-if="loginMode === 'code'" class="input-area code-area fade-up f-ct" style="animation-delay: 0.4s">
				<el-image :src="require('@/static/3.svg')"></el-image>
				<el-input v-model="code" :placeholder="$t('loginPage.codePlaceholder')">
					<template slot="suffix">
						<div class="code-suffix">
							<el-image class="divider-icon" :src="require('@/static/CodeBuddyAssets/31246_2226/2.svg')"></el-image>
							<span class="get-code" :class="{ disabled: counting }" @click="startCountdown">{{ counting ? countdown + 's' : $t('loginPage.getCode') }}</span>
						</div>
					</template>
				</el-input>
			</div>
			<div v-else class="input-area code-area fade-up f-ct" style="animation-delay: 0.4s">
				<el-image :src="require('@/static/3.svg')"></el-image>
				<el-input v-model="password" type="password" :placeholder="$t('loginPage.passwordPlaceholder')" show-password></el-input>
			</div>
			<!-- 切换登录方式 -->
			<div class="switch-login fade-up" style="animation-delay: 0.5s" @click="toggleMode">{{ loginMode === 'code' ? $t('loginPage.switchToPwd') : $t('loginPage.switchToCode') }}</div>
			<!-- 登录按钮 -->
			<div class="login-btn fade-up" style="animation-delay: 0.6s" @click="submitLogin">{{ $t('loginPage.loginBtn') }}</div>
			<!-- 注册提示 -->
			<div class="register-tip fade-up" style="animation-delay: 0.7s">{{ $t('loginPage.noAccount') }}&nbsp;<span class="link-text" @click="link('/register')">{{ $t('loginPage.toRegister') }}</span></div>
			<!-- 协议 -->
			<div class="agreement">
				<div class="checkbox-wrap" @click="agreed = !agreed">
					<el-image v-if="agreed" class="cb-bg" :src="require('@/static/add2/5.png')"></el-image>
					<el-image v-else class="cb-bg" :src="require('@/static/CodeBuddyAssets/31246_2226/3.svg')"></el-image>
				</div>
				<span class="agreement-text">{{ $t('loginPage.agreePrefix') }}&nbsp;<span class="link-text" @click="articleMsg(1)">{{ $t('loginPage.userAgreement') }}</span></span>
			</div>
		</div>
		<!-- ===== 协议弹窗 ===== -->
		<el-dialog
			:visible.sync="addMarkVisible"
			width="1264px"
			custom-class="add-mark-dialog"
			:show-close="false"
			:close-on-click-modal="false"
			@close="handleCloseDialog">
			<!-- 自定义头部 -->
			<div slot="title" class="dialog-header">
				<h2 class="dialog-title">{{atit}}</h2>
				<el-image class="dialog-close-icon" :src="require('@/static/sel/20.svg')" @click="addMarkVisible = false"></el-image>
			</div>
			<div class="txtBox" v-html="acontent"></div>
			<!-- 底部按钮区 -->
			<div slot="footer" class="dialog-footer">
				<button class="btn-confirm" @click="addMarkVisible = false">{{ $t('loginPage.confirm') }}</button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import {
	authMemberinfo,
	authMemberloginByPassword,
	authMemberloginByCode,
	smsmobile,
	smsemail,
	articledetail
} from "/src/api/api.js"
export default {
	data() {
		return {
			// 协议
			agreed: false,
			// 表单
			account: '',
			password: '',
			// 验证码
			code: '',
			countdown: 0,
			counting: false,
			timer: null,
			// 登录类型
			loginMode: 'password',
			// 弹出框
			addMarkVisible: false,
			atit:'',
			acontent:'',
		}
	},
	beforeDestroy() {
		if (this.timer) clearInterval(this.timer);
	},
	mounted() {
		// this.articleMsg(1)
	},
	methods: {
		// 文章详情
		async articleMsg(id){
			const res = await articledetail({id:id})
			if(res.code==200){
				this.atit = res.data.title
				this.acontent = res.data.content
				this.addMarkVisible = true
			}else{this.Tips(res.msg,'error');}
		},
		// 手机号密码登录/验证码登录
		async submitLogin(){
			if(!this.agreed){this.Tips(this.$t('loginPage.agreeFirst'),'error');return}
			var res;
			if(this.loginMode=='code'){
				res = await authMemberloginByCode({
					account:this.account,
					code:this.code,
				});
			}else{
				res = await authMemberloginByPassword({
					account:this.account,
					password:this.password,
				});
			}
			if(res.code==200){
				this.$store.commit('userMsg/tokenC',res.msg);
				this.getinfo()
			}else{this.Tips(res.msg,'error')}
		},
		// 获取用户信息
		async getinfo(){
			const res = await authMemberinfo({});
			if(res.code==200){
				this.$store.commit('userMsg/userInfoC',res.data);
				this.Tips(this.$t('loginPage.loginSuccess'),'success')
				setTimeout(()=>{
					this.link('/indexHome')
				},1500)
			}else{this.Tips(res.msg,'error')}
		},
		// 验证码
		async startCountdown() {
			if (this.counting) return;
			var res;
			var isEmail =  this.$regular.isEmail(this.account)
			if(isEmail){
				res = await smsemail({email:this.account});
			}else{
				res = await smsmobile({mobile:this.account});
			}
			if(res.code==200){
				this.counting = true;
				this.countdown = 120;
				this.timer = setInterval(() => {
					this.countdown--;
					if (this.countdown <= 0) {
						this.counting = false;
						clearInterval(this.timer);
						this.timer = null;
					}
				}, 1000);
			}else{this.Tips(res.msg,'error')}
		},
		// 切换登录类型
		toggleMode() {
			this.loginMode = this.loginMode === 'code' ? 'password' : 'code';
		},
	},
}
</script>

<style lang="scss" scoped>
@keyframes fadeInUp {
	from {
		opacity: 0;
		transform: translateY(0.15rem);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}
.fade-up {
	opacity: 0;
	animation: fadeInUp 0.5s ease forwards;
}
.page-wrap {
	position: relative;
	width: 100vw;
	height: 100vh;
	overflow: hidden;
}
.pbg {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: block !important;
	::v-deep .el-image__inner {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
}
.login-card {
	position: absolute;
	top: 50%;
	right: 2rem;
	transform: translateY(-50%);
	width: 4.74rem;
	height: 6.55rem;
	background: #fff;
	border-radius: 0.1rem;
	background: linear-gradient(180deg, rgba(255, 255, 255, 0.72) 0%, rgba(180, 215, 251, 0.6) 100%);

	border: 2px solid #fff;
	// border-image-source: linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.2) 46.15%, rgba(255, 255, 255, 0.6) 100%);
	

}
.title {
	position: absolute;
	top: 0.54rem;
	left: 0;
	right: 0;
	text-align: center;
	font-size: 0.24rem;
	font-weight: 500;
	color: #1D65B5;
}
.icon-wrap {
	// position: absolute;
	// top: 1.03rem;
	// left: 50%;
	// transform: translateX(-50%);
	.el-image {
		display: block;
		width: 168px;
		// height: 214px;
		margin: auto;
		margin-top: 48px;
	}
}
.input-area {
	position: absolute;
	left: 0.4rem;
	width: 3.94rem;
	height: 0.56rem;
	background: #F8F8F8;
	border-radius: 0.12rem;
	border: 0.01rem solid #E6E8EA;
	// background: #fff;
	padding-left: 18px;
	&.phone-area {
		top: 2.51rem;
	}
	&.code-area {
		top: 3.31rem;
	}
	::v-deep .el-input__inner {
		width: 100%;
		height: 0.56rem;
		background: transparent;
		border: none;
		padding: 0 0.18rem;
		padding-left: 12px;
		font-size: 0.16rem;
		color: #333;
		&::placeholder {
			color: #A5A8AF;
		}
	}
	::v-deep .el-input {
		height: 0.56rem;
		width: calc(100% - 34px);
	}
}
.code-area {
	::v-deep .el-input__inner {
		padding-right: 1.05rem;
	}
	::v-deep .el-input__suffix {
		right: 0.18rem;
		top: 50%;
		transform: translateY(-50%);
		display: flex;
		align-items: center;
	}
}
.code-suffix {
	display: flex;
	align-items: center;
	.divider-icon {
		width: 0.01rem;
		height: 0.2rem;
		margin-right: 0.25rem;
	}
	.get-code {
		color: #1D65B5;
		font-size: 0.16rem;
		cursor: pointer;
		white-space: nowrap;
		&.disabled {
			color: #1D65B5;
			cursor: not-allowed;
		}
	}
}
.pwd-login, .switch-login {
	position: absolute;
	top: 4.09rem;
	right: 0.4rem;
	font-size: 0.14rem;
	color: #1D65B5;
	cursor: pointer;
	&:hover {
		color: #1D65B5;
	}
}
.login-btn {
	position: absolute;
	top: 4.55rem;
	left: 0.4rem;
	width: 3.94rem;
	height: 0.48rem;
	background: #1D65B5;
	border-radius: 0.1rem;
	color: #fff;
	font-size: 0.18rem;
	font-weight: 500;
	text-align: center;
	line-height: 0.48rem;
	cursor: pointer;
	transition: all 0.3s ease;
	background: linear-gradient(90deg, #1F6EBD 0%, #0096FF 100%);

	// &:hover {
	// 	background: #33ABFF;
	// 	box-shadow: 0 0.04rem 0.12rem rgba(0, 150, 255, 0.4);
	// 	transform: translateY(-0.02rem);
	// }
	// &:active {
	// 	background: #0081D9;
	// 	transform: translateY(0);
	// 	box-shadow: 0 0.02rem 0.06rem rgba(0, 150, 255, 0.3);
	// }
}
.register-tip {
	position: absolute;
	top: 5.19rem;
	left: 0;
	right: 0;
	text-align: center;
	font-size: 0.16rem;
	color: #333333;
	.link-text {
		color: #1D65B5;
		cursor: pointer;
		&:hover {
			text-decoration: underline;
		}
	}
}
.agreement {
	position: absolute;
	top: 6.03rem;
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	align-items: center;
	.checkbox-wrap {
		width: 0.18rem;
		height: 0.18rem;
		position: relative;
		margin-right: 0.06rem;
		cursor: pointer;
		flex-shrink: 0;
		.cb-bg {
			position: absolute;
			top: 0;
			left: 0;
			width: 0.18rem;
			height: 0.18rem;
		}
		.cb-check {
			position: absolute;
			top: 0.03rem;
			left: 0.03rem;
			width: 0.12rem;
			height: 0.12rem;
		}
	}
	.agreement-text {
		font-size: 0.14rem;
		color: #333333;
		white-space: nowrap;
		.link-text {
			color: #1D65B5;
			cursor: pointer;
			&:hover {
				text-decoration: underline;
			}
		}
	}
}
/* ================================================================
   弹窗样式
   ================================================================ */

::v-deep .add-mark-dialog {
	border-radius: 8px;
	overflow: hidden;

	.el-dialog__header {
		padding: 0;
		margin: 0;
	}

	.el-dialog__body {
		padding: 30px 32px 20px;
		padding-bottom: 32px;
	}

	.el-dialog__footer {
		padding: 0 32px 28px;
	}
}


/* ---- 弹窗头部 ---- */
.dialog-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 69px;
	background: #f7fafc;
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
	padding: 0 30px;
	box-sizing: border-box;
}

.dialog-title {
	font-family: 'PingFang SC', sans-serif;
	font-size: 18px;
	font-weight: 500;
	color: #2F3541;
	margin: 0;
	line-height: 1;
}

.dialog-close-icon {
	width: 16px;
	height: 16px;
	cursor: pointer;
	transition: opacity 0.25s;

	&:hover {
		opacity: 0.7;
	}
}

/* ---- 弹窗底部按钮区 ---- */
.dialog-footer {
	display: flex;
	align-items: center;
	justify-content: center;
	padding-top: 4px;
}


/* 返回按钮 */
.btn-cancel {
	width: 120px;
	height: 44px;
	background: #E9F6FF;
	border: none;
	border-radius: 6px;
	font-family: 'PingFang SC', sans-serif;
	font-size: 16px;
	font-weight: 400;
	color: #0096FF;
	cursor: pointer;
	outline: none;
	transition: opacity 0.25s;

	&:hover {
		opacity: 0.85;
	}

	&:active {
		opacity: 1;
	}
}

.txtBox{
	height: 500px;
	overflow-y: scroll;
}

/* 确认修改按钮 */
.btn-confirm {
	width: 120px;
	height: 44px;
	background: #0096FF;
	border: none;
	border-radius: 6px;
	font-family: 'PingFang SC', sans-serif;
	font-size: 16px;
	font-weight: 400;
	color: #FFFFFF;
	cursor: pointer;
	outline: none;
	margin-left: 14px;
	transition: opacity 0.25s;

	&:hover {
		opacity: 0.88;
	}

	&:active {
		opacity: 1;
	}
}
</style>
